"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextAlign = exports.getLayoutProps = void 0;
/**
 * Helper function to determine text alignment based on layout
 * @param {string} layout - The layout type
 * @param {Object} headlineLockup - The headline lockup object
 * @returns {string} The text alignment value
 */
const getTextAlign = (layout, headlineLockup) => {
  return layout === 'stacked' ? 'center' : headlineLockup?.props?.textAlign || 'start';
};

/**
 * Helper function to get layout props based on layout type
 * @param {string} layout - The layout type
 * @returns {Object} The layout props object
 */
exports.getTextAlign = getTextAlign;
const getLayoutProps = layout => {
  if (layout === 'image-left') {
    return {
      'data-layout': 'image-left'
    };
  } else if (layout === 'image-right') {
    return {
      'data-layout': 'image-right'
    };
  } else if (layout === 'stacked') {
    return {
      'data-layout': 'stacked'
    };
  }
  return {};
};
exports.getLayoutProps = getLayoutProps;